// extracted by mini-css-extract-plugin
export default {"purchaseMethodPagePillButtons":"PurchaseMethod_purchaseMethodPagePillButtons__8hDg3"};